import { a as toggleModelDrawings, c as _delete, i as update4, l as create7, n as updatePlacements, o as findByProjectId, r as updateHighlightArea, s as downloadZipPages, t as updatePoints } from "./updatePoints.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/models/modelsDrawingsController/hooks/useCreate7.ts
const create7MutationKey = () => [{ url: "/api/models/drawing" }];
function create7MutationOptions(config = {}) {
	const mutationKey = create7MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body, headers }) => {
			const { data } = await create7({
				...config,
				body,
				headers,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Создать коллекцию чертежей модели.
* {@link /api/models/drawing}
*/
function useCreate7(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? create7MutationKey();
	const baseOptions = create7MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useDelete.ts
const deleteMutationKey = () => [{ url: "/api/models/drawing/:drawingId" }];
function deleteMutationOptions(config = {}) {
	const mutationKey = deleteMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await _delete({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Удалить коллекцию чертежей по переданному ид
* {@link /api/models/drawing/:drawingId}
*/
function useDelete(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteMutationKey();
	const baseOptions = deleteMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useDownloadZipPages.ts
const downloadZipPagesMutationKey = () => [{ url: "/api/models/drawing/zip/download" }];
function downloadZipPagesMutationOptions(config = {}) {
	const mutationKey = downloadZipPagesMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await downloadZipPages({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Скачать чертежи модели ZIP архивом по переданному списку id.
* {@link /api/models/drawing/zip/download}
*/
function useDownloadZipPages(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? downloadZipPagesMutationKey();
	const baseOptions = downloadZipPagesMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useFindByProjectId.ts
const findByProjectIdQueryKey = ({ path }) => [{
	url: "/api/models/drawing/project/:projectId",
	params: path
}];
function findByProjectIdQueryOptions({ path }, config = {}) {
	const queryKey = findByProjectIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await findByProjectId({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить коллекцию чертежей по переданному ид проекта
* {@link /api/models/drawing/project/:projectId}
*/
function useFindByProjectId({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? findByProjectIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...findByProjectIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useToggleModelDrawings.ts
const toggleModelDrawingsMutationKey = () => [{ url: "/api/models/drawing/placements/toggle" }];
function toggleModelDrawingsMutationOptions(config = {}) {
	const mutationKey = toggleModelDrawingsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await toggleModelDrawings({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Переключить привязку моделей к чертежам.
* {@link /api/models/drawing/placements/toggle}
*/
function useToggleModelDrawings(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? toggleModelDrawingsMutationKey();
	const baseOptions = toggleModelDrawingsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useUpdate4.ts
const update4MutationKey = () => [{ url: "/api/models/drawing" }];
function update4MutationOptions(config = {}) {
	const mutationKey = update4MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await update4({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Обновить коллекцию чертежей модели.
* {@link /api/models/drawing}
*/
function useUpdate4(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? update4MutationKey();
	const baseOptions = update4MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useUpdateHighlightArea.ts
const updateHighlightAreaMutationKey = () => [{ url: "/api/models/drawing/sheet/:drawingId/highlight-area" }];
function updateHighlightAreaMutationOptions(config = {}) {
	const mutationKey = updateHighlightAreaMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await updateHighlightArea({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Добавить точки наложения выделенной области для чертежа.
* {@link /api/models/drawing/sheet/:drawingId/highlight-area}
*/
function useUpdateHighlightArea(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updateHighlightAreaMutationKey();
	const baseOptions = updateHighlightAreaMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useUpdatePlacements.ts
const updatePlacementsMutationKey = () => [{ url: "/api/models/drawing/:drawingId/placements" }];
function updatePlacementsMutationOptions(config = {}) {
	const mutationKey = updatePlacementsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await updatePlacements({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Обновить привязку моделей к чертежу.
* {@link /api/models/drawing/:drawingId/placements}
*/
function useUpdatePlacements(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updatePlacementsMutationKey();
	const baseOptions = updatePlacementsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/models/modelsDrawingsController/hooks/useUpdatePoints.ts
const updatePointsMutationKey = () => [{ url: "/api/models/drawing/sheet/:drawingId/points/:modelId" }];
function updatePointsMutationOptions(config = {}) {
	const mutationKey = updatePointsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await updatePoints({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Добавить точки наложения чертежа на модель.
* {@link /api/models/drawing/sheet/:drawingId/points/:modelId}
*/
function useUpdatePoints(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updatePointsMutationKey();
	const baseOptions = updatePointsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { deleteMutationOptions as C, useCreate7 as D, create7MutationOptions as E, deleteMutationKey as S, create7MutationKey as T, findByProjectIdQueryOptions as _, updatePlacementsMutationOptions as a, downloadZipPagesMutationOptions as b, updateHighlightAreaMutationOptions as c, update4MutationOptions as d, useUpdate4 as f, findByProjectIdQueryKey as g, useToggleModelDrawings as h, updatePlacementsMutationKey as i, useUpdateHighlightArea as l, toggleModelDrawingsMutationOptions as m, updatePointsMutationOptions as n, useUpdatePlacements as o, toggleModelDrawingsMutationKey as p, useUpdatePoints as r, updateHighlightAreaMutationKey as s, updatePointsMutationKey as t, update4MutationKey as u, useFindByProjectId as v, useDelete as w, useDownloadZipPages as x, downloadZipPagesMutationKey as y };

//# sourceMappingURL=useUpdatePoints.js.map